export let IStylesParamsColorsKeys = /*#__PURE__*/function (IStylesParamsColorsKeys) {
  IStylesParamsColorsKeys["widgetBackgroundColor"] = "widgetBackgroundColor";
  IStylesParamsColorsKeys["widgetTitleColor"] = "widgetTitleColor";
  IStylesParamsColorsKeys["infoBackgroundColor"] = "infoBackgroundColor";
  IStylesParamsColorsKeys["borderColor"] = "borderColor";
  IStylesParamsColorsKeys["filterTitleColor"] = "filterTitleColor";
  IStylesParamsColorsKeys["filterSelectedIndicationColor"] = "filterSelectedIndicationColor";
  IStylesParamsColorsKeys["filterSelectedTextColor"] = "filterSelectedTextColor";
  IStylesParamsColorsKeys["filterSelectedBorderColor"] = "filterSelectedBorderColor";
  IStylesParamsColorsKeys["filterHoverIndicationColor"] = "filterHoverIndicationColor";
  IStylesParamsColorsKeys["filterHoverTextColor"] = "filterHoverTextColor";
  IStylesParamsColorsKeys["filterHoverBorderColor"] = "filterHoverBorderColor";
  IStylesParamsColorsKeys["filterBorderColor"] = "filterBorderColor";
  IStylesParamsColorsKeys["filterBackgroundColor"] = "filterBackgroundColor";
  IStylesParamsColorsKeys["dropdownTextColor"] = "dropdownTextColor";
  IStylesParamsColorsKeys["dropdownBorderColor"] = "dropdownBorderColor";
  IStylesParamsColorsKeys["dropdownBackgroundColor"] = "dropdownBackgroundColor";
  IStylesParamsColorsKeys["serviceImageBackgroundColor"] = "serviceImageBackgroundColor";
  IStylesParamsColorsKeys["servicesDividerColor"] = "servicesDividerColor";
  IStylesParamsColorsKeys["serviceDetailsColor"] = "serviceDetailsColor";
  IStylesParamsColorsKeys["courseAvailabilityColor"] = "courseAvailabilityColor";
  IStylesParamsColorsKeys["serviceNameColor"] = "serviceNameColor";
  IStylesParamsColorsKeys["serviceTaglineColor"] = "serviceTaglineColor";
  IStylesParamsColorsKeys["moreInfoButtonColor"] = "moreInfoButtonColor";
  IStylesParamsColorsKeys["serviceDividerColor"] = "serviceDividerColor";
  IStylesParamsColorsKeys["bookButtonBackgroundColor"] = "bookButtonBackgroundColor";
  IStylesParamsColorsKeys["holeBookButtonTextColor"] = "holeBookButtonTextColor";
  IStylesParamsColorsKeys["fillBookButtonTextColor"] = "fillBookButtonTextColor";
  IStylesParamsColorsKeys["bookButtonBorderColor"] = "bookButtonBorderColor";
  IStylesParamsColorsKeys["explorePlansTextColor"] = "explorePlansTextColor";
  return IStylesParamsColorsKeys;
}({});
export let IStylesParamsFontsKeys = /*#__PURE__*/function (IStylesParamsFontsKeys) {
  IStylesParamsFontsKeys["widgetTitleFont"] = "widgetTitleFont";
  IStylesParamsFontsKeys["filterTitleFont"] = "filterTitleFont";
  IStylesParamsFontsKeys["dropdownTextFont"] = "dropdownTextFont";
  IStylesParamsFontsKeys["serviceNameFont"] = "serviceNameFont";
  IStylesParamsFontsKeys["courseAvailabilityFont"] = "courseAvailabilityFont";
  IStylesParamsFontsKeys["serviceTagLineFont"] = "serviceTagLineFont";
  IStylesParamsFontsKeys["moreInfoButtonFont"] = "moreInfoButtonFont";
  IStylesParamsFontsKeys["serviceDetailsFont"] = "serviceDetailsFont";
  IStylesParamsFontsKeys["bookButtonFont"] = "bookButtonFont";
  IStylesParamsFontsKeys["explorePlansFont"] = "explorePlansFont";
  return IStylesParamsFontsKeys;
}({});
export let ILegacyStylesParamsFontsKeys = /*#__PURE__*/function (ILegacyStylesParamsFontsKeys) {
  ILegacyStylesParamsFontsKeys["OFFERING_NAME_FONT"] = "OFFERING_NAME_FONT";
  ILegacyStylesParamsFontsKeys["CATEGORY_NAME_FONT"] = "CATEGORY_NAME_FONT";
  ILegacyStylesParamsFontsKeys["MULTI_OFFERINGS_TITLE_FONT"] = "MULTI_OFFERINGS_TITLE_FONT";
  ILegacyStylesParamsFontsKeys["MOBILE_CATEGORY_NAME_FONT"] = "MOBILE_CATEGORY_NAME_FONT";
  ILegacyStylesParamsFontsKeys["COURSE_AVAILABILITY_FONT"] = "COURSE_AVAILABILITY_FONT";
  ILegacyStylesParamsFontsKeys["OFFERING_TAGLINE_FONT"] = "OFFERING_TAGLINE_FONT";
  ILegacyStylesParamsFontsKeys["OFFERING_MORE_INFO_LABEL_FONT"] = "OFFERING_MORE_INFO_LABEL_FONT";
  ILegacyStylesParamsFontsKeys["OFFERING_DETAILS_FONT"] = "OFFERING_DETAILS_FONT";
  ILegacyStylesParamsFontsKeys["BUTTON_TEXT_FONT"] = "BUTTON_TEXT_FONT";
  ILegacyStylesParamsFontsKeys["EXPLORE_PLANS_FONT"] = "EXPLORE_PLANS_FONT";
  return ILegacyStylesParamsFontsKeys;
}({});
export let IStylesParamsNumbersKeys = /*#__PURE__*/function (IStylesParamsNumbersKeys) {
  IStylesParamsNumbersKeys["mobileWidgetTitleFontSize"] = "mobileWidgetTitleFontSize";
  IStylesParamsNumbersKeys["borderWidth"] = "borderWidth";
  IStylesParamsNumbersKeys["mobileFilterTitleFontSize"] = "mobileFilterTitleFontSize";
  IStylesParamsNumbersKeys["filterBorderWidth"] = "filterBorderWidth";
  IStylesParamsNumbersKeys["filterBorderRadius"] = "filterBorderRadius";
  IStylesParamsNumbersKeys["filterSpacing"] = "filterSpacing";
  IStylesParamsNumbersKeys["dropdownBorderWidth"] = "dropdownBorderWidth";
  IStylesParamsNumbersKeys["overlappingSidePadding"] = "overlappingSidePadding";
  IStylesParamsNumbersKeys["overlappingVerticalPadding"] = "overlappingVerticalPadding";
  IStylesParamsNumbersKeys["stripBorderWidth"] = "stripBorderWidth";
  IStylesParamsNumbersKeys["stripSidePadding"] = "stripSidePadding";
  IStylesParamsNumbersKeys["stripVerticalPadding"] = "stripVerticalPadding";
  IStylesParamsNumbersKeys["imageAndTextRatio"] = "imageAndTextRatio";
  IStylesParamsNumbersKeys["mobileServiceNameFontSize"] = "mobileServiceNameFontSize";
  IStylesParamsNumbersKeys["mobileServiceTaglineFontSize"] = "mobileServiceTaglineFontSize";
  IStylesParamsNumbersKeys["mobileMoreInfoButtonFontSize"] = "mobileMoreInfoButtonFontSize";
  IStylesParamsNumbersKeys["serviceDividerWidth"] = "serviceDividerWidth";
  IStylesParamsNumbersKeys["classicSidePadding"] = "classicSidePadding";
  IStylesParamsNumbersKeys["classicVerticalPadding"] = "classicVerticalPadding";
  IStylesParamsNumbersKeys["gridSidePadding"] = "gridSidePadding";
  IStylesParamsNumbersKeys["gridVerticalPadding"] = "gridVerticalPadding";
  IStylesParamsNumbersKeys["mobileServiceDetailsFontSize"] = "mobileServiceDetailsFontSize";
  IStylesParamsNumbersKeys["mobileBookButtonFontSize"] = "mobileBookButtonFontSize";
  IStylesParamsNumbersKeys["bookButtonBorderWidth"] = "bookButtonBorderWidth";
  IStylesParamsNumbersKeys["bookButtonCornerRadius"] = "bookButtonCornerRadius";
  IStylesParamsNumbersKeys["mobileExplorePlansFontSize"] = "mobileExplorePlansFontSize";
  return IStylesParamsNumbersKeys;
}({});
//# sourceMappingURL=stylesParamsKeys.js.map